import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class DialogModalService {

  constructor(
    private NgbModal: NgbModal
  ) { }


  /**
   * 
   * @param data 
   * @param component 
   */
  open(data: any = null, component: any, size:string = 'lg', windowClass:any = {}): any {

    const modalRef = this.NgbModal.open(component, { centered: true, size: size, windowClass});

    modalRef.componentInstance.data = data;

    return modalRef.result;
  }

  
  /**
   * 
   * @param data 
   * @param component 
   */
  openExpandedFilter(data: any = null, component: any): any {
  
    const modalRef = this.NgbModal.open(component, { centered: false});

    modalRef.componentInstance.data = data;

    return modalRef.result;
  }
}

